import { render, staticRenderFns } from "./VuesticDataTable.vue?vue&type=template&id=33190abe&"
import script from "./VuesticDataTable.vue?vue&type=script&lang=js&"
export * from "./VuesticDataTable.vue?vue&type=script&lang=js&"
import style0 from "./VuesticDataTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticDataTable.vue"
export default component.exports